import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { tableConfig } from "../../../../commons/table/config/tableConfig";
import { booleanSubrowColumn } from "./columns";



const ArtFormsConfigurationTable = ({ loading, handleDelete, handleEdit }) => {
  const { data, isFetching } = useSelector((state) => state.forms.formsPermissionsByRole);
  const columns = useMemo(() => [
    {
      header: "Rol",
      accessorKey: "tipo",
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const parent = row.getParentRow();
        const tipo = parent ? parent.getValue(columnId) : row.getValue(columnId);
        return tipo.toLowerCase().includes(filterValue.toLowerCase());
      },
    },
    {
      header: "Formulario",
      accessorKey: "formulario",
      filterFn: 'includesString',
    },
    booleanSubrowColumn({ header: "Ver", accessorKey: "ver" }),
    booleanSubrowColumn({ header: "Crear", accessorKey: "crear" }),
    booleanSubrowColumn({ header: "Editar", accessorKey: "editar" }),
    booleanSubrowColumn({ header: "Borrar", accessorKey: "borrar" }),
  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns: columns,
    data: data,
    enableExpanding: true,
    getSubRows: (row) => row.permisos,
    displayColumnDefOptions: {
      'mrt-row-expand': {
        size: 40,
      },
      'mrt-row-actions': { size: 90 }
    },
    filterFromLeafRows: true,
    layoutMode: "grid",
    paginateExpandedRows: false,
    state: { isLoading: loading || isFetching },
    positionActionsColumn: "last",
    enableRowActions: true,
    renderRowActions: ({ row, table }) => {

      const parent = row.getParentRow();

      return (
        <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
          <IconButton
            onClick={() => {
              handleEdit({
                ...row.original,
                ...(parent ? parent.original : null),
                parent: !!parent,
              });
            }}
          >
            <EditIcon />
          </IconButton>
          {
            !!parent && (
              <IconButton
                color="error"
                onClick={() => {
                  handleDelete({
                    ...row.original,
                    ...(parent ? parent.original : null),
                    parent: !!parent,
                  });
                }}
              >
                <DeleteIcon />
              </IconButton>
            )
          }
        </Box >
      );
    }
  });

  return (
    <div>
      <MaterialReactTable table={table} />
    </div>
  );
};

export default ArtFormsConfigurationTable;